import { Skeleton } from '~/shared/ui/SkeletonList'

export function LoadingBlock() {
  return (
    <>
      <Skeleton animated $height={26} style={{ marginBottom: '24px' }} />

      <Skeleton animated $height={19} style={{ marginBottom: '16px' }} />

      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '23px' }} />

      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '23px' }} />

      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
      <Skeleton animated $height={19} style={{ marginBottom: '3px' }} />
    </>
  )
}
